import authService from "@/services/authService";
import router from "../../../router"; // import router from "@/router";

export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    user: null,
    updateUserStatus: null,
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    getUser: (state) => state.user,
  },
  mutations: {
    SET_IS_AUTHENTICATED(state, payload) {
      state.isAuthenticated = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    async doSignIn({ commit }, payload) {
      try {
        const data = {
          username: payload.username,
          password: payload.password,
        };

        const response = await authService.login(data);

        if (response.status === "success" && response.token) {
          localStorage.setItem("auth-token", response.token);
          commit("SET_IS_AUTHENTICATED", true);
          commit("SET_USER", response.data);
          router.push({ name: "home" });
        }

        return response;
      } catch (error) {
        console.log("error", error);
        return error.response;
      }
    },

    async initAuth({ commit }) {
      try {
        const token = localStorage.getItem("auth-token");

        if (!token) {
          return null;
        }

        const response = await authService.verifyUser(token);

        if (response.status === "success") {
          commit("SET_USER", response.data);
          commit("SET_IS_AUTHENTICATED", true);
          router.push({ name: "home" });
        }

        return response.data;
      } catch (error) {
        return error.response;
      }
    },

    async doSignOut({ commit }) {
      try {

        const response = await authService.logout();
        commit("SET_IS_AUTHENTICATED", false);
        localStorage.removeItem("auth-token");
        router.push({ name: "signin" });

        return response;
      } catch {
        return null;
      }
    },

    async getUserInfos() {
      try {
        const token = localStorage.getItem("auth-token");
        if (!token) {
          return null;
        }
        const response = await authService.verifyUser(token);
        return response;
      } catch (error) {
        console.log("error", error);
      }
    },

    async updateProfileRequest() {

      try {
        const response = await authService.updateProfileRequest();
        return response;
      } catch (error) {
        console.log("error", error);
      }

    },


    async checkVerificationCode(_, code) {
      try {
        const body = {
          code: code,
        };

        const response = await authService.checkVerificationCode(body);
        return response;
      } catch (error) {
        console.log("error", error);
      }
    },

    async updateUserInfos(_, payload) {

      try {

        const body = {
          resetToken: payload.resetToken || null,
          fullname: payload.fullname,
          email: payload.email,
          password: payload.password,
          images: payload.images,
        }

        const response = await authService.updateUserInfos(body);
        return response;

      } catch (error) {
        console.log("error", error);
      }
    },

    async uploadImage(_, image) {
      try {
        let formData = new FormData();
        for (var i = 0; i < image.length; i++) {
          let file = image[i];
          formData.append("images", file);
        }
        const response = await authService.uploadImage(formData);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
